<mat-list-item>
  <mat-icon
    matListItemIcon
    igoCollapse
    class="igo-chevron catalog-browser-group-carret"
    [target]="items"
    [collapsed]="collapsed()"
    (toggle)="onToggleCollapsed($event)"
  >
    expand_less
  </mat-icon>

  <span
    class="igo-catalog-group-title"
    matListItemTitle
    matTooltipShowDelay="500"
    [matTooltip]="title"
    (click)="onTitleClick()"
    >{{ title }}</span
  >

  <div matListItemMeta>
    @if (group().externalProvider) {
      <mat-icon
        class="igo-cataloggroup-external-icon"
        color="primary"
        tooltip-position="below"
        matTooltipShowDelay="500"
        [matTooltip]="'igo.geo.catalog.externalProvider.group' | translate"
      >
        public
      </mat-icon>
    }

    @if ((added$ | async) && (preview$ | async) === false) {
      <button
        mat-icon-button
        tooltip-position="below"
        matTooltipShowDelay="500"
        [matTooltip]="'igo.geo.catalog.group.removeFromMap' | translate"
        color="warn"
        [disabled]="disabled$ | async"
        (click)="onToggleClick($event)"
      >
        <mat-icon>delete</mat-icon>
      </button>
    } @else {
      <button
        mat-icon-button
        tooltip-position="below"
        matTooltipShowDelay="500"
        [matTooltip]="'igo.geo.catalog.group.addToMap' | translate"
        [disabled]="disabled$ | async"
        (click)="onToggleClick($event)"
      >
        <mat-icon>add</mat-icon>
      </button>
    }
  </div>
</mat-list-item>

<div #items>
  @for (item of store.view.all$() | async; track item) {
    @if (isGroup(item)) {
      <!-- todo: add display ans manage CatalogItemGroup -->
    }
    @if (isLayer(item)) {
      <igo-catalog-browser-layer
        igoListItem
        [layer]="$any(item)"
        [resolution]="resolution()"
        [map]="map()"
        [catalogAllowLegend]="catalogAllowLegend()"
        [added]="state().get(item).added"
        (addedLayerIsPreview)="onLayerPreview($event)"
        (addedChange)="onLayerAddedChange($event)"
      />
    }
  }
</div>
